<template>
  <VAppLayout>
    <VPageHeader :title="$t('pages.tip.title')" />
    <VContainer>
      <div class="tips-container">
        <div class="tips-subtitle" v-html="$t('pages.tip.subtitle')"></div>
        <div class="waiters-wrapper">
            <div v-for="waiter in waitersList" :key="waiter.id" class="waiter-item" @click="openWaiterPage(waiter.code)">
              <div class="waiter-avatar">
                <img
                    v-if="waiter.imagePath.length > 5"
                    :src="waiter.imagePath"
                    :alt="waiter.name"
                    @error="handleImageError"
                    :class="{ 'image-error': imageLoadError }"
                />
                <img
                    v-else
                    src="@/assets/img/tiptip/userPlaceholder.png"
                    :alt="waiter.name"
                />
              </div>
              <h2>{{ waiter.name }}</h2>
            </div>
        </div>
        <div class="waiters-footer">
          <a href="https://tiptip.com.pl/"
             target="_blank"
             rel="noopener"
             class="tiptip-credit">
            <img :src="tiptipLogo" alt="TipTip" class="tiptip-credit__logo" />
            <span>{{ $t('pages.tip.footer') }}</span>
          </a>
        </div>
      </div>
    </VContainer>
  </VAppLayout>
</template>

<script>

import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VPageHeader from "@/components/ui/VPageHeader.vue";
import { getTheme } from "@/utils/theme";

export default {
  name: "TipsTab",
  components: {
    VContainer,
    VAppLayout,
    VPageHeader,
  },
  data() {
    return {
      isDark: getTheme() === 'dark',
    };
  },
  computed: {
    waitersList() {
      let list = this.$store.getters['getWaitersList'];
      list = list.filter(waiter => waiter.is_active === 1);
      return list;
    },
    tiptipLogo() {
      // White wordmark on dark, the regular (dark) logo on light.
      return this.isDark
        ? require('@/assets/img/tiptip/tiptip-white-sm.png')
        : require('@/assets/img/tiptip/tiptip-logo.png');
    }
  },
  methods: {
    openWaiterPage(code) {
      //open new tab
      const url = `https://daj.tiptip.com.pl/${code}`;
      window.open(url, '_blank');
    },
    handleImageError() {
      this.imageLoadError = true;
      // Можна замінити src на placeholder
      event.target.src = require('@/assets/img/tiptip/userPlaceholder.png');
    }
  }
}
</script>

<style scoped>
.tips-container {
  /* Bottom padding clears the floating nav. We can't rely on min-height:100%
     + the layout's scroll padding here: when the waiter list is long the
     container overflows VContainer (height:100%) and that padding is bypassed,
     hiding the footer behind the dock. So the container grows with content and
     carries the dock clearance itself. */
  padding: 20px 0 calc(var(--nav-height) + var(--nav-float-gap) * 2 + var(--safe-bottom) + 24px);
  max-width: 700px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.tips-container .tips-subtitle {
  margin-bottom: 18px;
  font-size: var(--text-base);
  color: var(--text-secondary);
  font-weight: var(--weight-medium);
  line-height: 1.45;
}

.tips-container .waiters-wrapper {
  gap: 10px;
  flex-flow: column;
  display: flex;
}

.tips-container .waiters-wrapper .waiter-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: var(--surface-subtle);
  border-radius: var(--radius-3xl);
  border: 1px solid var(--border-subtle);
  padding: 5px;
  -webkit-tap-highlight-color: transparent;
  transition: transform var(--dur-fast) var(--ease-standard),
              box-shadow var(--dur-base) var(--ease-standard);
}

.tips-container .waiters-wrapper .waiter-item:active {
  transform: scale(0.98);
  box-shadow: var(--shadow-sm);
}

.tips-container .waiters-wrapper .waiter-item .waiter-avatar {
  margin-right: 15px;
}

.tips-container .waiters-wrapper .waiter-item .waiter-avatar img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50px;
}

.tips-container .waiters-wrapper .waiter-item h2 {
  font-size: var(--text-lg);
  margin: 0;
  font-weight: var(--weight-bold);
  color: var(--text-primary);
}

.tips-container .waiters-footer {
  margin-top: 32px;
  padding: 20px 0 0 0;
  text-align: center;
  color: var(--text-muted);
  font-size: var(--text-xs);
}

.tips-container .waiters-footer .tiptip-credit {
  display: inline-flex;
  flex-flow: column;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
  transition: transform var(--dur-fast) var(--ease-standard);
}

.tips-container .waiters-footer .tiptip-credit:active {
  transform: scale(0.97);
}

.tips-container .waiters-footer .tiptip-credit__logo {
  height: 26px;
  width: auto;
}

.tips-container .waiters-footer .tiptip-credit span {
  margin: 0;
}
</style>
